import * as React from "react"
import {Route, Switch} from "react-router-dom"
import * as routes from "../../util/routes"
import AideList from "./aide-list"
export default class AideComponent extends React.Component {
	render() {
		return (
			<Switch>
				<Route exact path={routes.AIDE} component={AideList}/>
				{/* <Route path={routes.INSTRUCTIONS_DETAIL} component={InstructionDetail}/> */}
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/component/aide/index.tsx